const worksData = [
  {
    id: '1',
    icon: './assets/mobile.png',
    title: 'Front End Skills',
    desc:
        'I enjoy building web application using new Front-End technologies, including JavaScript ES6, React, Redux ...',
    img:
        './assets/frontend.png',
    skills: [
      {
        id: '1',
        name: 'HTML5',
        color: '#e34f26',
        logo: './assets/languages/html.png',
      },
      {
        id: '2',
        name: 'CSS3',
        color: '#3a7bd5', // '#3a7bd5',
        logo: './assets/languages/css.png',
      },
      {
        id: '3',
        name: 'JavaScript ES6',
        color: '#f1e05a',
        logo: './assets/languages/js.png',
      },
      {
        id: '4',
        name: 'ReactJS',
        color: '#61dafb',
        logo: './assets/languages/react.png',
      },
      {
        id: '11',
        name: 'React Native',
        color: '#61dafd',
        logo: './assets/languages/react.png',
      },
      {
        id: '5',
        name: 'Redux',
        color: '#764abc',
        logo: './assets/languages/redux.png',
      },
      {
        id: '6',
        name: 'Bootstrap',
        color: '#563d7c',
        logo: './assets/languages/bootstrap.png',
      },
      {
        id: '7',
        name: 'Material-UI',
        color: '#7c5e57',
        logo: './assets/languages/mui.png',
      },
      {
        id: '8',
        name: 'Sass',
        color: '#c2412d',
        logo: './assets/languages/sass.png',
      },
      {
        id: '9',
        name: 'Tailwind',
        color: '#1DA1F2',
        logo: './assets/languages/tailwind.png',
      },
      {
        id: '10',
        name: 'Jest',
        color: '#99415b',
        logo: './assets/languages/jest.png',
      },
    ],

  },
  {
    id: '2',
    icon: './assets/writing.png',
    title: 'Back End Skills',
    desc:
        'I have experience in building RESTful APIs using Ruby on Rails with PostgreSQL as the database.',
    img:
        'https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg',
    skills: [
      {
        id: '2',
        name: 'Ruby',
        color: '#e34f22',
        logo: './assets/languages/ruby.png',
      },
      {
        id: '3',
        name: 'Ruby on Rails',
        color: '#e34f26',
        logo: './assets/languages/rubyonrails.png',
      },
      {
        id: '4',
        name: 'Devise',
        color: 'gray',
        logo: './assets/languages/devise.png',
      },
      {
        id: '5',
        name: 'PostgreSQL',
        color: '#764abc',
        logo: './assets/languages/postgresql.png',
      },
      {
        id: '6',
        name: 'MongoDB',
        color: '#8fac6a',
        logo: './assets/languages/mongodb.png',
      },
      {
        id: '7',
        name: 'Rspec',
        color: '#7c5e57',
        logo: './assets/languages/rspec.png',
      },
      {
        id: '8',
        name: 'RESTful API',
        color: '#c2412d',
        logo: './assets/languages/api.png',
      },
      {
        id: '9',
        name: 'JWT',
        color: 'lightgray',
        logo: './assets/languages/jwt.png',
      },
      {
        id: '10',
        name: 'Capybara',
        color: '#e34f26',
        logo: './assets/languages/capybara.png',
      },
    ],
  },
  {
    id: '3',
    icon: './assets/tools.png',
    title: 'Tools & Libraries',
    desc:
        'Using these tools and libraries to build web application is my passion and I love to learn new techs.',
    img:
        './assets/tools-bg.png',
    skills: [
      {
        id: '20',
        name: 'CodePen',
        color: '#3A3B3C',
        logo: './assets/languages/codepen.png',
      },
      {
        id: '0',
        name: 'VS Code',
        color: '#0277BD',
        logo: './assets/languages/vscode.png',
      },
      {
        id: '1',
        name: 'GitLab',
        color: '#ff7043',
        logo: './assets/languages/gitlab.png',
      },
      {
        id: '2',
        name: 'Git',
        color: '#f03ce6',
        logo: './assets/languages/git.png',
      },
      {
        id: '11',
        name: 'GitHub',
        color: '#171515',
        logo: './assets/languages/github.png',
      },
      {
        id: '12',
        name: 'ArcGIS',
        color: '#5D9874',
        logo: './assets/languages/arcgis.png',
      },
      {
        id: '13',
        name: 'Canva',
        color: '#00c4cc',
        logo: './assets/languages/canva.png',
      },
      {
        id: '14',
        name: 'Test Driven Development',
        color: '#764abc',
        logo: './assets/languages/tdd.png',
      },
      {
        id: '15',
        name: 'Agile Development',
        color: '#203983',
        logo: './assets/languages/agile.png',
      },
      {
        id: '16',
        name: 'Linters',
        color: '#7c5e57',
        logo: './assets/languages/linters.png',
      },
      {
        id: '17',
        name: 'GitHub Flow',
        color: '#c2412d',
        logo: './assets/languages/githubflow.png',
      },
    ],
  },
];

export default worksData;
